import { isPast } from 'date-fns';

import type { TimeDifference } from '@localization/hooks/useCountdown';

type EventCountdownState = Readonly<{
  isEventFuture: boolean;
  isEventDay: boolean;
  hasEventPassed: boolean;
}>;

const INACTIVE_STATE: EventCountdownState = {
  isEventFuture: false,
  isEventDay: false,
  hasEventPassed: false,
};

/**
 * Derives the countdown display state from the event date and countdown data.
 *
 * `useCountdown` uses `Math.abs` internally so `countDown.days` is always
 * non-negative, even after the event timestamp has passed.  Without the
 * explicit `isPast` check, same-day-but-already-passed events would still
 * appear as "event day" and multi-day-past events as "future."
 */
export const getEventCountdownState = (eventDate: number | undefined, countDown: TimeDifference, needsCountdown: boolean): EventCountdownState => {
  if (!needsCountdown || eventDate == null) {
    return INACTIVE_STATE;
  }
  const hasEventPassed = isPast(eventDate);
  return {
    hasEventPassed,
    isEventFuture: countDown.days > 0 && !hasEventPassed,
    isEventDay: countDown.days === 0 && !hasEventPassed,
  };
};
